<template>
    <div class="Studiomat" :class="{StudiomatReady: !loading}">

        <div class="StudiomatVisualization">

            <div class="StudiomatSlotMachine">

                <div class="StudiomatSlotMachineHeader">
                    <img src="./assets/slotmachine-top.svg" alt="Slotmachine Header">
                </div>

                <div class="StudiomatSlotMachineColumns">

                    <div v-for="(slot, index) in slots"  v-bind:key="index" class="StudiomatSlotMachineCol">
                        <div class="StudiomatSlotMachineInner">
                            <img :src="slot.img">
                        </div>
                    </div>

                    <div :class="{active: running}" @click.prevent="next()" class="StudiomatSlotMachineHandle">
                        <div class="StudiomatSlotMachineHandleInner">
                            <div class="StudiomatSlotMachineHandleBulb"></div>
                            <div class="StudiomatSlotMachineHandleKnob"></div>
                            <div class="StudiomatSlotMachineHandleNote">Zum Bestätigen den Hebel betätigen.</div>
                        </div>
                    </div>

                </div>

            </div>

            <div v-if="debug">
                <pre>{{ total }}</pre>
                <!-- <pre>{{ images }}</pre> -->
                <!-- <pre>{{ endResult }}</pre> -->
                <!-- <pre>{{ sentenceBlockA }}</pre> -->
                <!-- <pre>{{ sentenceBlockB }}</pre> -->
            </div>

        </div>

        <div class="StudiomatEvaluation">

            <div class="StudiomatProgressWrap">
                <div class="StudiomatProgress">
                    <div class="StudiomatProgressBar" :style="'width:' + progress + '%'">{{ progress }}%</div>
                </div>
            </div>

            <div class="StudiomatQuestions">

                <tiny-slider ref="questionSlider" v-bind="questionsSliderOptions">

                    <div class="StudiomatQuestion" v-for="question in preparedQuestions" v-bind:key="question.index">

                        <h4 class="StudiomatQuestionText">{{ question.question }}</h4>

                        <p v-if="question.type === 'radio'" class="StudiomatQuestionNote">Nur <strong>eine</strong> Antwort ist möglich.</p>
                        <p v-if="question.type === 'checkbox'" class="StudiomatQuestionNote">Du hast mindestens <strong>eine</strong> und maximal <strong>vier</strong> Antwortmöglichkeiten.</p>

                        <div class="StudiomatQuestionAlerts"></div>

                        <div class="StudiomatChoices">
                            <div class="StudiomatChoice" v-for="(choice, index) in question.choices" v-bind:key="index">

                                <input
                                    v-on:keyup.enter.once="next(question)"
                                    v-model="question.result"
                                    :type="question.type"
                                    :value="index"
                                    :id="'StudiomatChoiceInput-' + question.index + '-' + index"
                                    :name="'StudiomatChoiceInput-' + (question.type == 'checkbox' ? question.index + '-' + index : question.index)"
                                >

                                <label :for="'StudiomatChoiceInput-' + question.index + '-' + index">

                                    <span class="StudiomatChoiceIcon"></span>
                                    <span class="StudiomatChoiceText">{{ choice.text }}</span>

                                    <pre v-if="debug">{{ choice.value }}</pre>

                                </label>

                            </div>
                        </div>

                        <button class="StudiomatButtonPrev StudiomatButton StudiomatButtonBlock" @click.prevent="prev(question)" tabindex="-1" v-if="debug">Zurück</button>
                        <button class="StudiomatButtonNext StudiomatButton StudiomatButtonBlock" @click.prevent="next(question)" tabindex="-1">Weiter</button>

                        <!-- <span class="StudiomatChoiceBlock">Block {{ question.block.toUpperCase() }}</span> -->

                    </div>

                    <div class="StudiomatQuestion">

                        <div v-if="endResult.a.index !== undefined" class="StudiomatEndResult">

                            <div class="StudiomatEndResultImage">
                                <img v-for="(image, index) in images" v-bind:key="index" :src="image" :alt="image" width="100">
                            </div>

                            <div class="StudiomatEndResultSentences">
                                <p class="StudiomatEndResultSentence" v-html="sentenceBlockA"></p>
                                <p class="StudiomatEndResultSentence" v-html="sentenceBlockB"></p>
                            </div>

                            <div class="StudiomatEndResultButtons">
                                <button class="StudiomatButton" @click.prevent="reset()" tabindex="-1">Neu beginnen</button>
                            </div>

                        </div>

                    </div>

                </tiny-slider>

            </div>

        </div>

        <div class="StudiomatLoadingOverlay">
            <div class="StudiomatLoadingInner">
                Studiomat wird geladen
            </div>
        </div>

        <svg style="display:none!important;">
            <symbol v-for="icon in icons" v-bind:key="icon.id" :id="icon.id" viewBox="0 0 24 24">
                <title>{{ icon.name }}</title>
                {{ icon.content }}
            </symbol>
        </svg>

    </div>
</template>

<script>
// https://github.com/viktorlarsson/vue-tiny-slider
import VueTinySlider from 'vue-tiny-slider';
import axios from 'axios';
import { slice, chunk, shuffle, flatten, isEmpty, isNumber, inRange, meanBy, toArray, first, last, sortBy } from 'lodash';

export default {
    name: 'StudiomatWidget',
    components: {
        'tiny-slider': VueTinySlider
    },
    data() {
        return {
            debug: false,
            // sendUrl: 'https://studiomat-stats.13-grad.com/',
            publicPath: process.env.BASE_URL,
            isProd: process.env.NODE_ENV === 'production',
            questionsSliderOptions: {
                autoHeight: true,
                controls: false,
                touch: false,
                loop: false,
            },
            images: [],
            links: [],
            sentenceBlockA: '',
            sentenceBlockB: '',
            slots: [
                {
                    img: require('./assets/hs-nb-logo.png'),
                },
                {
                    img: require('./assets/hs-nb-logo.png'),
                },
                {
                    img: require('./assets/hs-nb-logo.png'),
                }
            ],
            loading: true,
            loadingTime: 1000,
            running: false,
            maxQuestions: {
                a: 9,
                b: 3,
            },
            icons: require('./assets/icons.json'),
            courses: [
                {
                    label: 'Agrarwirtschaft',
                    icon: require('./assets/icon-agrarwirtschaft.svg'),
                    animation: require('./assets/Animations-0.gif'),
                    link: 'https://www.hs-nb.de/index.php?id=156545',
                },
                {
                    label: 'Lebensmitteltechnologie',
                    icon: require('./assets/icon-lebensmitteltechnologie.svg'),
                    animation: require('./assets/Animations-1.gif'),
                    link: 'https://www.hs-nb.de/index.php?id=156551',
                },
                {
                    label: 'Diätetik',
                    icon: require('./assets/icon-diaetetik.svg'),
                    animation: require('./assets/Animations-2.gif'),
                    link: 'https://www.hs-nb.de/index.php?id=156553',
                }
            ],
            questions: {
                a: require('./questions/block-a.json'),
                b: require('./questions/block-b.json'),
            },
            sentences: {
                a: [
                    'Du hast den kleinen Jackpot gewonnen, denn mit <strong>:average:</strong> haben alle drei Studiengänge die gleiche Priorität für dich. Hör’ auf dein Bauchgefühl oder spiel’ noch einmal.',
                    'Super! Du bist zu <strong>:average:</strong> für den Studiengang <a href=":link:" title=":label:"><strong>:label:</strong></a> geeignet.',
                    'Jackpot! You are the winner - drei Richtige! <a href=":link:" title=":label:"><strong>:label:</strong></a> ist genau dein Ding. Schreib’ dich noch heute ein.',
                ],
                b: [
                    'Hinzu kommt, dass du nicht so leicht zu beeindrucken bist, aber in einer guten WG in Neubrandenburg lernst du das wahre Studentenleben kennen.',
                    'Außerdem hast du mit Neubrandenburg und der Hochschule viel gemeinsam. Worauf wartest du noch?',
                    'Und übrigens! Du hast ein Match. Sei ehrlich! In deinem früheren Leben warst du ein Neubrandenburger. Pack die Koffer - die Hochschule und die Stadt warten auf dich!',
                ]
            },
            results: {
                a: {},
                b: {},
            },
            total: {
                a: {},
                b: {},
            },
            preparedQuestions: [],
            cookieKey: 'studiomat_visitor_identity',
            currentIndex: 0,
            endResult: {
                a: {
                    index: null,
                    average: null,
                },
                b: {
                    average: null,
                },
            },
            windowWidth: 0,
        }
    },
    created() {
        let _this = this;

        _this.preparedQuestions = _this.getQuestions();

        setTimeout(function(){
            _this.loading = false;
        }, _this.loadingTime);
    },
    computed: {
        progress() {
            return Math.floor(100 / this.totalQuestionCount * this.currentIndex);
        },
        totalQuestionCount() {
            return this.maxQuestions.a + this.maxQuestions.b;
        },
    },
    methods: {
        getWindowWidth(){
            return window.innerWidth;
        },
        getQuestions() {
            const QuestionsBlockA = slice(shuffle(this.questions.a), 0, this.maxQuestions.a);
            const QuestionsBlockB = slice(shuffle(this.questions.b), 0, this.maxQuestions.b);

            let questionIndex = 0;

            for( var a in QuestionsBlockA ) {
                QuestionsBlockA[a]['block'] = 'a';
                questionIndex++;
            }

            for( var b in QuestionsBlockB ) {
                QuestionsBlockB[b]['block'] = 'b';
                questionIndex++;
            }

            const questionBlocks = chunk(QuestionsBlockA, 3);

            for( var block in questionBlocks ) {
                questionBlocks[block].push(QuestionsBlockB[block]);
            }

            const questions = flatten(questionBlocks);

            let choiceIndex = 0;

            for( var q in questions ) {
                let question = questions[q],
                    choices  = question.choices;

                question['index']  = q;
                question['result'] = [];

                for( var c in choices ) {
                    choices[c]['index'] = choiceIndex;

                    choiceIndex++;
                }
            }

            return questions;
        },
        setSentence() {

            let _this  = this,
                courses = _this.courses,
                result = _this.endResult,
                index  = result.a.index,
                course = courses[index],
                IntlNumberFormat = new Intl.NumberFormat('de-DE', {style: 'percent', minimumFractionDigits: 0}),
                // sentenceBlockA = course.sentence,
                sentenceBlockA = '',
                sentenceBlockB = '';

            // console.log( course );

            _this.images = [];

            if( result.a.average > 1/2 && result.a.average <= 1 ) {

                sentenceBlockA = _this.sentences.a[2];
                _this.images.push(course.icon);

            } else
            if( result.a.average > 1/3 && result.a.average <= 1/2 ) {

                sentenceBlockA = _this.sentences.a[1];
                _this.images.push(course.icon);

            } else
            if( result.a.average >= 0 && result.a.average <= 1/3 ) {

                sentenceBlockA = _this.sentences.a[0];

                _this.courses.forEach(function(course){
                    _this.images.push(course.icon);
                });

            }

            sentenceBlockA = _this.replaceAll(sentenceBlockA, ':label:', course.label);
            sentenceBlockA = _this.replaceAll(sentenceBlockA, ':link:', course.link);
            sentenceBlockA = _this.replaceAll(sentenceBlockA, ':average:', IntlNumberFormat.format(result.a.average));

            if( result.b.average > 1/2 && result.b.average <= 1 ) {
                sentenceBlockB = _this.sentences.b[2];
            } else
            if( result.b.average > 1/3 && result.b.average <= 1/2 ) {
                sentenceBlockB = _this.sentences.b[1];
            } else
            if( result.b.average >= 0 && result.b.average <= 1/3 ) {
                sentenceBlockB = _this.sentences.b[0];
            }

            _this.sentenceBlockA = sentenceBlockA;
            _this.sentenceBlockB = sentenceBlockB;

        },
        setAverage( results ) {

            let blockA = results.a,
                blockB = results.b,
                currents = {
                    a: {},
                    b: null,
                },
                totals = {
                    a: [],
                    b: [],
                };

            for( var A in blockA ) {

                let answersA = blockA[A].answers;

                currents.a = {
                    ag: meanBy(answersA, function(value) {
                        return eval(value.value.ag);
                    }),
                    lt: meanBy(answersA, function(value) {
                        return eval(value.value.lt);
                    }),
                    di: meanBy(answersA, function(value) {
                        return eval(value.value.di);
                    }),
                };

                totals.a.push(currents.a);

            }

            for( var B in blockB ) {

                let answersB = blockB[B].answers;

                currents.b = meanBy(answersB, function(value) {
                    return eval(value.value);
                });

                totals.b.push(currents.b);

            }

            this.total = {
                a: {
                    ag: meanBy(totals.a, function(value) {
                        return eval(value.ag);
                    }),

                    lt: meanBy(totals.a, function(value) {
                        return eval(value.lt);
                    }),

                    di: meanBy(totals.a, function(value) {
                        return eval(value.di);
                    }),
                },
                b: meanBy(totals.b, function(value) {
                    return eval(value);
                })
            }

            return {
                currents: currents,
                totals:   totals,
                total:    this.total,
            };

        },
        updateSlotMachine( averages ) {

            let _this = this,
                isLastIndex = (_this.currentIndex+1) >= _this.totalQuestionCount,
                isMatomo = typeof _paq !== 'undefined',
                AverageA = toArray(averages.a),
                AverageB = averages.b;

            // let sliders = [
            //     _this.$refs.slotSlider1.slider,
            //     _this.$refs.slotSlider2.slider,
            //     _this.$refs.slotSlider3.slider,
            // ];

            let final       = {};
            let one         = [];
            let oneOthers   = [];
            let two         = [];
            let twoOthers   = [];
            let three       = [];
            let threeOthers = [];

            AverageA.forEach(function(average, index){
                if( average <= (1/3) ) {
                    one.push({index, average});
                } else {
                    oneOthers.push({index, average});
                }

                if( average > (1/3) && average < 0.5 ) {
                    two.push({index, average});
                } else {
                    twoOthers.push({index, average});
                }

                if( average >= 0.5 ) {
                    three.push({index, average});
                } else {
                    threeOthers.push({index, average});
                }
            });

            _this.endResult.b = {
                average: AverageB
            };

            if( one.length > 0 ) {
                let values = shuffle(one);
                let value  = first(values);

                final = [];

                values.forEach(function(value){
                    final.push(value.index);
                });

                // Set end result
                _this.endResult.a = {
                    index: value.index,
                    average: value.average,
                };

                _this.trackingData = [
                    'trackEvent',
                    'Studiomat',
                    'BlockA',
                    _this.courses[value.index].label,
                    _this.courses[value.index].icon
                ];
            }

            if( two.length > 0 ) {
                let values = shuffle(two);
                let value  = first(values);

                final = [];

                // Twice
                final.push(value.index);
                final.push(value.index);

                if( values.length > 1 ) {
                    final.push(
                        last(sortBy(values.filter(function(v){
                            return v.index !== value.index;
                        }))).index
                    );
                } else {
                    final.push( last(sortBy(twoOthers)).index );
                }

                // Set end result
                _this.endResult.a = {
                    index: value.index,
                    average: value.average,
                };

                _this.trackingData = [
                    'trackEvent',
                    'Studiomat',
                    'BlockA',
                    _this.courses[value.index].label,
                    _this.courses[value.index].icon
                ];
            }

            if( three.length > 0 ) {
                let values = shuffle(three);
                let value  = first(values);

                final = [];

                final.push(value.index);
                final.push(value.index);
                final.push(value.index);

                // Set end result
                _this.endResult.a = {
                    index: value.index,
                    average: value.average,
                };

                _this.trackingData = [
                    'trackEvent',
                    'Studiomat',
                    'BlockA',
                    _this.courses[value.index].label,
                    _this.courses[value.index].icon
                ];
            }

            _this.setSentence();

            // https://matomo.org/docs/event-tracking/
            if( isMatomo && isLastIndex ) {
                _paq.push(_this.trackingData);
            }

            shuffle(final).forEach(function(value, index){
                _this.slots[index].img = _this.courses[value].animation + '?' + _this.guid();
            });

            if( _this.getWindowWidth() < 992 ) {
                _this.scrollTop(document.querySelector('.Studiomat'), 300, 'easeInOutCubic');
            }

            // final.forEach(function(v, i){
            //     sliders[i].goTo(v*5);
            // });

            // setTimeout( function(){
            //     final.forEach(function(v, i){
            //         sliders[i].goTo(v);
            //     });
            // }, options.speed);

            // setTimeout( function(){
            //     final.forEach(function(v, i){
            //         sliders[i].refresh();
            //     });
            // }, options.speed*2 );

        },
        prev( question, event ) {

            this.currentIndex--;

            this.$refs.questionSlider.slider.goTo('prev');

        },
        next( question, event ) {

            let _this = this;

            _this.running = true;

            if( question === undefined ) {
                question = _this.preparedQuestions[_this.currentIndex];
            }

            let rule        = false,
                message     = '',
                slider      = this.$refs.questionSlider.slider,
                infos       = slider.getInfo(),
                slide       = infos.slideItems[infos.index],
                alerts      = slide.querySelector('.StudiomatQuestionAlerts'),
                type        = question.type,
                block       = question.block,
                result      = question.result,
                choices     = question.choices,
                values      = [];

            // Delete cookie if it exists
            if( _this.currentIndex === 0 ) {
                _this.setCookie(_this.cookieKey, "", -1);
            }

            if( isNumber(result) ) {

                let val = choices[result];

                values = {
                    index: question.index,
                    question: question.question,
                    answers: [val]
                };

            } else {

                let multipleValues = [];

                for ( var r in result ) {

                    let val = result[r];

                    multipleValues.push(choices[val]);

                }

                values = {
                    index: question.index,
                    question: question.question,
                    answers: multipleValues
                };

            }

            switch( type ) {

                case 'radio':
                    rule    = !isEmpty(values.answers);
                    message = 'Bitte wähle eine Antwort aus.';
                    break;

                case 'checkbox':
                    rule    = !isEmpty(values.answers) && inRange(values.answers.length, 0, 5);
                    message = 'Bitte wähle mindestens 1 und maximal 4 Antworten aus.';
                    break;

                default:
                    rule    = !isEmpty(values.answers);
                    message = 'Ein Fehler ist aufgetreten.';
                    break;

            }

            alerts.innerHTML = '';

            if( rule ) {

                // let language = navigator.language || navigator.userLanguage;

                _this.results[block][question.index] = values;

                let average = _this.setAverage(_this.results);

                // console.log( average.total );

                // let data = {
                //     participant: _this.getPersistentVisitorId(),
                //     language: language,
                //     question: values.question,
                //     choices: values.answers,
                //     block: block,
                //     type: type,
                //     avg_question: average.currents[block],
                //     avg_total: average.total,
                //     question_index: _this.currentIndex,
                //     question_total_count: _this.totalQuestionCount,
                // };

                // if( _this.debug === false ) {
                //     _this.sendStats(data);
                // }

                _this.updateSlotMachine(average.total);
                _this.currentIndex++;
                slider.goTo('next');

            } else {

                let alert           = document.createElement('div');
                    alert.classList = 'StudiomatAlertDanger';
                    alert.innerHTML = '<span class="StudiomatIcon">' + this.svg('warning') + '</span> ' + message;

                _this.scrollTop(document.querySelector('.StudiomatEvaluation'), 300, 'easeInOutCubic');

                alerts.appendChild(alert);

                slider.updateSliderHeight();

            }

            setTimeout(function () {
                _this.running = false;
            }, 300);

        },
        // sendStats( data ) {

        //     let _this = this;

        //     if( _this.isProd === false ) {
        //         console.log(data);
        //         return;
        //     }

        //     axios.post(_this.sendUrl + 'api/participant/send', data)
        //         .then(function (response) {
        //             if( _this.debug === true ) {
        //                 console.log(response.data);
        //             }
        //         })
        //         .catch(function (error) {
        //             if( _this.debug === true ) {
        //                 alert('Ein Fehler ist aufgetreten. Bitte sieh in die Entwicklerkonsole!');
        //                 console.log(error);
        //             }
        //         })
        //     ;

        // },
        reset() {
            // Not the best way, but the fastes for me ;-)
            window.location.reload(false);
        },
        svg( name ) {
            return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' + this.icons[name] + '</svg>';
        },

        // https://gist.github.com/emilisto/6229488
        getPersistentVisitorId () {
            let _this = this,
                _key  = _this.cookieKey,
                _guid = _this.getCookie(_key);

            if( !_guid ) {
                _guid = _this.guid();
                _this.setCookie(_key, _guid, 7);
            }

            return _guid;
        },

        guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
            };
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        },

        // https://gist.github.com/skorecky/1636080
        setCookie (name, value, days) {
            if (!name && !value) {
                return false;
            } else if (days) {
                var date = new Date();
                date.setTime(date.getTime()+(days*24*60*60*1000));
                var expires = "; expires="+date.toGMTString();
            }
            else var expires = "";
            document.cookie = name+"="+value+expires+"; path=/";
            return value;
        },

        getCookie (name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        },

        replaceAll(string, search, replace) {
            return string.replace(new RegExp(search, 'g'), replace);
        },

        scrollTop(destination, duration = 200, easing = 'linear', callback ) {

            // window.scrollTo(0, 0);

            const easings = {
                linear(t) {
                    return t;
                },
                easeInQuad(t) {
                    return t * t;
                },
                easeOutQuad(t) {
                    return t * (2 - t);
                },
                easeInOutQuad(t) {
                    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
                },
                easeInCubic(t) {
                    return t * t * t;
                },
                easeOutCubic(t) {
                    return (--t) * t * t + 1;
                },
                easeInOutCubic(t) {
                    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
                },
                easeInQuart(t) {
                    return t * t * t * t;
                },
                easeOutQuart(t) {
                    return 1 - (--t) * t * t * t;
                },
                easeInOutQuart(t) {
                    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
                },
                easeInQuint(t) {
                    return t * t * t * t * t;
                },
                easeOutQuint(t) {
                    return 1 + (--t) * t * t * t * t;
                },
                easeInOutQuint(t) {
                    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
                }
            };

            const start = window.pageYOffset;
            const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

            const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
            const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
            const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
            const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

            if ('requestAnimationFrame' in window === false) {
                window.scroll(0, destinationOffsetToScroll);
                if (callback) {
                    callback();
                }
                return;
            }

            function scroll() {
                const now = 'now' in window.performance ? performance.now() : new Date().getTime();
                const time = Math.min(1, ((now - startTime) / duration));
                const timeFunction = easings[easing](time);
                window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

                if (window.pageYOffset === destinationOffsetToScroll) {
                    if (callback) {
                        callback();
                    }
                return;
                }

                requestAnimationFrame(scroll);
            }

            scroll();

        },
    }
}
</script>

<style lang="scss">
@import '../node_modules/tiny-slider/src/tiny-slider';

$primary:       #DB0031;
$danger:        hsl(348, 100%, 61%);
$success:       hsl(141, 71%, 48%);

$line-space:    20px;
$loading-size:  32px;

$text-color:    #333;

$checkbox-radio-size:   28px;
$checkbox-radio-border: 2px;
$checkbox-radio-space:  0px;

$breakpoint: 992px;

.Studiomat {
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    line-height: 1.4;
    font-weight: 400;
    font-size: 16px;
    color: $text-color;

    display: flex;
    flex-direction: column;

    @media screen and ( min-width: $breakpoint ) {
        flex-direction: row;
    }

    * {
        box-sizing: border-box;
    }

    p {
        margin-top: 0;
        margin-bottom: $line-space;
    }

    a {
        text-decoration: none;
        border-radius: 5px;
        color: $primary;
    }

    a:hover {
        color: darken($primary, 8);
    }

    .StudiomatButton {
        display: inline-block;
        text-transform: uppercase;
        background: $primary;
        border-radius: 6px;
        color: #fff;
        line-height: 1.5;
        cursor: pointer;
        font-size: 14px;
        padding: 10px 20px;
        margin: 0;
        border: 0;
    }

    .StudiomatButton + .StudiomatButton {
        margin-left: $line-space / 2;
    }

    .StudiomatButton:hover {
        background: darken($primary, 5);
        color: #fff;
    }

    .StudiomatButton:focus,
    .StudiomatButton:active {
        background: lighten($primary, 5);
    }

    .StudiomatButtonLarge {
        padding: 15px 30px;
        font-size: 18px;
    }

    .StudiomatButtonBlock {
        width: 100%;

        + [class^="StudiomatButton"] {
            margin-left: 0;
            margin-top: $line-space / 2;
        }
    }

    .StudiomatIcon {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        bottom: -0.14em;
    }

    .StudiomatIcon svg {
        width: 1em;
        height: 1em;
        fill: none;
        stroke: currentColor;
        stroke-width: 3px;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    [class^="StudiomatAlert"] {
        padding: 12px 15px;
        font-size: 14px;
        color: #fff;
        margin-bottom: $line-space;
    }

    [class^="StudiomatAlert"] .StudiomatIcon {
        margin-right: 5px;
    }

    .StudiomatQuestionAlerts:empty {
        display: none;
    }

    .StudiomatAlertDanger {
        background: $danger;
    }

    .StudiomatAlertSuccess {
        background: $success;
    }

    .StudiomatProgressWrap {
        padding: $line-space $line-space 0;
    }

    .StudiomatProgress {
        background: #EBE9EA;
    }

    .StudiomatProgressBar {
        transition: 0.3s ease-in-out;
        background: #455052;
        height: 15px;
        color: #fff;
        // font-size: 12px;
        font-size: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        white-space: nowrap;

        @media screen and ( min-width: $breakpoint ) {
            height: 30px;
        }
    }

    .StudiomatVisualization {
        font-size: 12px;
        padding: 0 0;
        margin-bottom: $line-space / 2;

        @media screen and ( min-width: $breakpoint ) {
            flex: 0 0 50%;
            max-width: 50%;
            padding: 0 6% 0 0;
            margin-bottom: 0;
        }
    }

    .StudiomatSlotMachineHeader::before,
    .StudiomatSlotMachineColumns::before,
    .StudiomatSlotMachineColumns::after {
        content: ' ';
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    .StudiomatSlotMachineHeader {
        user-select: none;
        pointer-events: none;
        position: relative;
        z-index: 0;
    }

    .StudiomatSlotMachineColumns {
        position: relative;
        padding: 1rem;
        display: flex;
        z-index: 0;

        &:after {
            content: ' ';
            background-image: url('./assets/slotmachine-bottom.svg');
            background-size: 100% 100%;
            position: absolute;
            z-index: 5;
        }
    }

    .StudiomatSlotMachineHeader::before,
    .StudiomatSlotMachineColumns::before {
        background: #fff;
        top: 1em;
        right: 1em;
        left: 1em;
        bottom: 1em;
        z-index: -1;
    }

    .StudiomatSlotMachine {
        position: relative;
    }

    .StudiomatSlotMachine img {
        display: block;
        width: 100%;
        height: auto;
    }

    .StudiomatSlotMachineCol {
        user-select: none;
        pointer-events: none;
        max-width: (100% / 3);
        flex: 0 0 (100% / 3);
    }

    .StudiomatSlotMachineInner {
        position: relative;
        overflow: hidden;
        padding-top: 100%;
        height: 0;
    }

    .StudiomatSlotMachineInner img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .StudiomatSlotMachineInner .tns-item {
        padding: 10%;
    }

    .StudiomatSlotMachineCol:nth-child(1) {
        .StudiomatSlotMachineInner .tns-item {
            padding-left: 13%;
            padding-right: 7%;
        }
    }

    .StudiomatSlotMachineCol:nth-child(3) {
        .StudiomatSlotMachineInner .tns-item {
            padding-left: 7%;
            padding-right: 13%;
        }
    }

    .StudiomatSlotMachineHandle {
        transform: translateY(-50%);
        position: absolute;
        left: 100%;
        top: 50%;
        width: 14%;
        background: transparent;
        border: 0;
        padding: 0;
        margin: 0;
        transform-style: preserve-3d;

        @media screen and ( max-width: ($breakpoint - 1) ) {
            display: none;
        }
    }

    .StudiomatSlotMachineHandleInner {
        display: flex;
        align-items: center;
        perspective: 300px;
    }

    .StudiomatSlotMachineHandleNote {
        position: absolute;
        top: 160px;
        right: 79px;
        width: 210px;
        text-transform: uppercase;
        border-radius: 10px;
        padding: 6px 8px;
        font-size: 14px;
        text-align: center;
        border: 1px dashed #555;
        color: #555;

        &:before {
            content: ' ';
            position: absolute;
            top: -115px;
            right: -20px;
            height: 119px;
            transform: rotate(20deg);
            width: 0;
            border-right: 1px dashed #555;
        }
    }

    .StudiomatSlotMachineHandleBulb {
        background-image: url('./assets/slotmachine-handle-bulb.svg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        flex: 0 0 50%;
        width: 50%;
        height: 0;
        padding-top: 107%;
        z-index: 5;
    }

    .StudiomatSlotMachineHandleKnob {
        background-color: transparent;
        background-image: url('./assets/slotmachine-handle-knob.svg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        border: 0;
        padding: 0;
        margin: 0;
        flex: 0 0 50%;
        width: 50%;
        height: 0;
        padding-top: 203%;
        align-items: flex-end;
        position: absolute;
        right: 0;
        // transform: rotate3d(1, 0, 0, 0deg) translate(-50%, -38%);
        transform: rotateX(0deg) translate(-50%, -38%);
        transition: 0.2s ease;
        cursor: pointer;
        z-index: 10;
    }

    .StudiomatSlotMachineHandle {

        &:focus {
            outline: none;
        }

        &:hover .StudiomatSlotMachineHandleKnob {
            // transform: rotate3d(1, 0, 0, -5deg) translate(-50%, -37%);
            transform: rotateX(-5deg) translate(-50%, -37%);
        }

        &.active .StudiomatSlotMachineHandleKnob {
            // transform: rotate3d(1, 0, 0, -120deg) translate(-50%, -24%);
            transform: rotateX(-120deg) translate(-50%, -24%);
        }
    }

    .StudiomatEvaluation {
        border-radius: 10px;
        background: #fff;

        @media screen and ( min-width: $breakpoint ) {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }

    .StudiomatQuestion {
        position: relative;
        padding: $line-space;

        @media screen and ( min-width: $breakpoint ) {
            .StudiomatButtonNext {
                display: none;
            }
        }
    }

    .StudiomatQuestionText {
        user-select: none;
        text-transform: uppercase;
        word-spacing: 1px;
        font-weight: 400;
        font-size: 16px;
        margin-top: 0;
        margin-bottom: $line-space;
        color: $text-color;

        @media screen and ( min-width: $breakpoint ) {
            font-size: 22px;
        }
    }

    .StudiomatQuestionNote {
        font-size: 14px;
        color: #888;
    }

    .StudiomatQuestionNote:before {
        content: 'Hinweis: ';
        font-weight: bold;
    }

    .StudiomatChoices {
        margin-bottom: $line-space;
        font-size: 14px;
        color: #666;
    }

    .StudiomatChoice {
        position: relative;
        margin-bottom: 3px;
    }

    .StudiomatChoice > input {
        position: absolute;
        clip: rect(0, 0, 0, 0);
        opacity: 0;
        margin: 0;
    }

    .StudiomatChoice > label {
        user-select: none;
        cursor: pointer;
        display: inline-block;
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        padding: round($line-space / 3);
        margin-left: round(-$line-space / 3);
        margin-right: round(-$line-space / 3);
        z-index: 0;
    }

    // .StudiomatChoice > label:before {
    //     content: '';
    //     border-radius: 6px;
    //     background: #eee;
    //     position: absolute;
    //     height: 100%;
    //     width: 0;
    //     left: 0;
    //     top: 0;
    //     transition: 0.2s;
    //     z-index: -1;
    // }

    .StudiomatChoiceIcon {
        position: relative;
        border: $checkbox-radio-border solid $primary;
        margin-right: $checkbox-radio-size * 0.5;
        height: $checkbox-radio-size;
        width: $checkbox-radio-size;
        max-width: $checkbox-radio-size;
        flex: 0 0 $checkbox-radio-size;
    }

    .StudiomatChoiceIcon::before {

        content: ' ';
        position: absolute;
        background: $primary;
        will-change: transform, opacity;
        transition: 0.2s;
        transform: scale(0.3);
        opacity: 0;

        $checkbox-radio-space-checked:  $checkbox-radio-space;
        $checkbox-radio-size-checked:   calc(100% - #{round($checkbox-radio-space * 2)} );

        @if $checkbox-radio-space == 0 {
            $checkbox-radio-space-checked:  round(-$checkbox-radio-border / 2);
            $checkbox-radio-size-checked:   calc(100% + #{$checkbox-radio-border} );
        }

        top: $checkbox-radio-space-checked;
        left: $checkbox-radio-space-checked;
        height: $checkbox-radio-size-checked;
        width: $checkbox-radio-size-checked;

    }

    .StudiomatChoice > input[type="radio"] + label .StudiomatChoiceIcon,
    .StudiomatChoice > input[type="radio"] + label .StudiomatChoiceIcon:before {
        border-radius: 50%;
    }

    .StudiomatChoiceText {
        display: flex;
        align-items: center;
        color: #888;
        flex: 1 0;
    }

    // .StudiomatChoice > input:checked + label:before {
    //     width: 100%;
    // }

    .StudiomatChoice > input:checked + label .StudiomatChoiceIcon::before {
        transform: scale(1);
        opacity: 1;
    }

    .StudiomatEndResult {
        // display: flex;
        text-align: center;
        font-size: 16px;

        @media screen and ( min-width: $breakpoint ) {
            padding-left: 50px;
            padding-right: 50px;
            margin-bottom: $line-space;
            font-size: 20px;
        }
    }

    .StudiomatEndResultImage img {
        width: 130px;
        height: auto;
        margin-top: -20px;
    }

    &:not(.StudiomatReady)  {
        cursor: progress;
        overflow: hidden;
        height: 200px;

        .StudiomatLoadingOverlay {
            visibility: visible;
            opacity: 1;
        }

        .StudiomatVisualization,
        .StudiomatEvaluation {
            visibility: visible;
            opacity: 0;
        }
    }

    &.StudiomatReady {
        .StudiomatLoadingOverlay {
            visibility: hidden;
            opacity: 0;
        }

        .StudiomatVisualization,
        .StudiomatEvaluation {
            visibility: visible;
            opacity: 1;
        }
    }

    .StudiomatLoadingOverlay {
        background: $primary;
        border-radius: 10px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transition: 0.5s;
        visibility: visible;
        opacity: 1;
        z-index: 500;
        user-select: none;
    }

    .StudiomatLoadingInner {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        transform: translateY(-50%);
        text-transform: uppercase;
        letter-spacing: 0.2px;
        text-align: center;
        word-spacing: 1px;
        font-weight: 700;
        font-size: 10px;
        color: #fff;
    }

    .StudiomatLoadingInner::before {
        border: round($loading-size * 0.15) solid #fff;
        border-left-color: transparent;
        border-radius: $loading-size;
        display: block;
        margin: 0 auto 0.7rem;
        content: ' ';
        width: $loading-size;
        height: $loading-size;
        animation: StudiomatChoiceRotate 0.6s linear infinite;
        z-index: 600;
    }
}

// http://animista.net/play/basic/rotate
@keyframes StudiomatChoiceRotate {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
